/*
  ====================
  ==Goals analytics==
  ====================
*/

function goalsAnalyticsTrigger(contentType, contentId) {
  gtag('event', 'select_content', {
    'content_type': contentType,
    'content_id': contentId
  });
}

$(function(){

  window.Parsley.setLocale($('html').attr('lang'));

  if ($('form.parsley').length > 0){
    $('form.parsley').parsley();
  }

  if ($('img.unveil').length > 0) {
    $('img.unveil').unveil(250);
  }

  $(".search-link").on("click",function(){
    $(".main-site-container").toggleClass("search-active");
    $(".search-box").fadeToggle("slow");
  });

  $(".search-box .backdrop").on("click",function(){
    $(".main-site-container").toggleClass("search-active");
    $(".search-box").fadeToggle("slow");
  });

  $(document).keyup(function(e) {
    if (e.key === "Escape") {
      if($(".main-site-container").hasClass("search-active")){
        $(".main-site-container").toggleClass("search-active");
        $(".search-box").fadeToggle("slow");
      }
    }
  });

  /*
  ==========
  ==MAILCHIMP==
  ==========
  */
  if ($('.mailchimpForm').length > 0) {
    $('.mailchimpForm').parsley();

    $('.mailchimpForm').on('submit', function(e){
      e.preventDefault();

      var that = $(this),
      url = that.attr('action'),
      method = that.attr('method'),
      error = $('html').attr('lang') == 'fr' ? "Impossible d'inscrire votre courriel à notre infolettre. Veuillez vérifier votre courriel ou nous contacter." : "We cannot subscribe your email. Please check your email or contact us.";

      that.find('.mailchimpSubmit').attr('disabled', 'disabled').css('opacity', '0.4');

      $.ajax({
        url: url,
        type: method,
        dataType: 'json',
        data: that.serialize(),
      })
      .done(function(data) {
        that.find('.alert').html('');

        if (data.success) {
          that.find('.alert-success').html(data.message);
        }
        else {
          that.find('.alert-error').html(error);
        }
      })
      .fail(function() {
        that.find('.alert').html('');
        that.find('.alert-error').html(error);
      })
      .always(function() {
        that.find('.mailchimpSubmit').removeAttr('disabled').css('opacity', '1');
      });
    });
  }

  /*
  ==========
  ==Logout==
  ==========
  */
  $('#logout').on('click', function(e){
    e.preventDefault();

    var that = $(this),
    href = that.data('href'),
    home = that.data('home');

    $.get(href, function(data) {
      window.location.href = home;
    });
  });

  /*
  ===============
  ==Mobile Menu==
  ===============
  */
  $(".menu.mobile").click(function(){
    $(this).toggleClass("active");
    $(".mobile-overlay").fadeToggle( "slow", "linear" );
    $("#main-content, #main-footer, header#main-header nav#main-nav .nav ,body").toggleClass("active");
  });
  $(".nav .has-sub").on("click",function(){
    $(this).toggleClass("active");
  });

  /*
  ==========================
  ==Smooth Scroll function==
  ==========================
  */
  $('a[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');

      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000);

        return false;
      }
    }
  });

  /*
  ====================
  ==Open a modal box==
  ====================
  */
  var myModal = "";

  $(".modal-trigger").click(function(){
    myModal = $(this).attr("href");
    $(myModal).fadeIn("slow");
    $(".modal-overlay").fadeIn("slow");
  });

  $(".modal-footer .btn").click(function(){
    $(myModal).fadeOut("slow");
    $(".modal-overlay").fadeOut("slow");
  });

  /*
  =======================
  ==Newsletter reminder==
  =======================
  */
  if ($(".pop-up.newsletter").length > 0) {
    setTimeout(function(){
      $(".pop-up.newsletter").fadeToggle();
    }, 2000);

    $(".pop-up.newsletter .close-btn").on("click",function(){
      var that = $(this),
      closeUrl = $(".pop-up.newsletter").data('close');

      $(".pop-up.newsletter").fadeToggle();

      $.post(closeUrl, {}, function(data, textStatus, xhr) {});
    });
  }

  /*
  ==========
  ==Pop-up==
  ==========
  */
  if ($(".pop-up-webinaire").length > 0) {
    var myPopUp = $(".pop-up-webinaire");
    var myCookie = readCookie('pop-web');
    if(myCookie){
      $(".bottom-btn").css("display","block");
    }
    if(!myCookie){
      setTimeout(function(){
        myPopUp.fadeToggle();
        createCookieWDay("pop-web",true,2);
      }, 3000);
    }
    $(".pop-up-webinaire .close-btn").on("click",function(){
      myPopUp.fadeToggle();
      $(".bottom-btn").fadeToggle();
    });
    $(".bottom-btn").on("click",function(){
      $(this).fadeToggle();
      myPopUp.fadeToggle();
    });
  }

  if($(".pop-up-rencontre").hasClass("fr")){
    var myPopUp2 = $(".pop-up-rencontre");
    var myCookie2 = readCookie('pop-web-3');
    if(!myCookie2){
      setTimeout(function(){
        myPopUp2.fadeToggle();
      }, 3000);
    }
    $(".pop-up-rencontre .close-btn").on("click",function(e){
      e.preventDefault();
      myPopUp2.fadeToggle();
      createCookieWDay("pop-web-3",true,4);
    });
    $(document).on('keyup', function(e) {
      if (e.key == "Escape") myPopUp2.fadeToggle();
    });
  }
});